export const de = {
  // Auth
  'auth.login': 'Anmelden',
  'auth.register': 'Registrieren',
  'auth.logout': 'Abmelden',
  'auth.email': 'E-Mail',
  'auth.password': 'Passwort',
  'auth.username': 'Benutzername',
  'auth.confirmPassword': 'Passwort bestätigen',
  'auth.forgotPassword': 'Passwort vergessen?',
  'auth.resetPassword': 'Passwort zurücksetzen',
  'auth.resetPasswordDesc': 'Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen.',
  'auth.sendResetLink': 'Link senden',
  'auth.resetLinkSent': 'Ein Link zum Zurücksetzen wurde an {{email}} gesendet.',
  'auth.backToLogin': 'Zurück zum Login',
  'auth.noAccount': 'Noch kein Konto?',
  'auth.hasAccount': 'Bereits ein Konto?',
  'auth.usernameAvailable': 'Verfügbar',
  'auth.usernameTaken': 'Vergeben',
  'auth.usernameInvalid': 'Nur Buchstaben und Zahlen, max. 10 Zeichen',
  'auth.usernameChecking': 'Prüfe...',
  'auth.passwordMismatch': 'Passwörter stimmen nicht überein',
  'auth.loginWithGoogle': 'Mit Google anmelden',
  'auth.orDivider': 'oder',
  'auth.logoutMessage': 'Du wurdest abgemeldet.',

  // Account / Settings
  'account.title': 'Mein Konto',
  'account.profile': 'Profil',
  'account.changeEmail': 'E-Mail ändern',
  'account.changePassword': 'Passwort ändern',
  'account.changeAddress': 'Adresse ändern',
  'account.newEmail': 'Neue E-Mail',
  'account.currentPassword': 'Aktuelles Passwort',
  'account.newPassword': 'Neues Passwort',
  'account.confirmNewPassword': 'Neues Passwort bestätigen',
  'account.street': 'Straße',
  'account.zip': 'PLZ',
  'account.city': 'Stadt',
  'account.country': 'Land',
  'account.save': 'Speichern',
  'account.saved': 'Gespeichert!',
  'account.emailConfirmation': 'Eine Bestätigungs-E-Mail wurde an {{email}} gesendet.',
  'account.passwordChanged': 'Passwort erfolgreich geändert.',
  'account.memberSince': 'Mitglied seit {{date}}',

  // Home
  'home.welcome': 'Willkommen',
  'home.welcomeGuest': 'Willkommen, Gast',
  'home.description': 'Dein Startpunkt für alles.',

  // General
  'general.loading': 'Laden...',
  'general.error': 'Fehler',
  'general.success': 'Erfolg',
  'general.cancel': 'Abbrechen',
  'general.delete': 'Löschen',
  'songbook.duration': 'Dauer',

  // Songbook
  'songbook.title': 'Songbook',
  'songbook.newSong': 'Neuer Song',
  'songbook.untitled': 'Ohne Titel',
  'songbook.noSongs': 'Noch keine Songs vorhanden.',
  'songbook.deleteSong': 'Song löschen',
  'songbook.deleteConfirm': 'Song wirklich löschen?',
  'songbook.saved': 'Gespeichert',
  'songbook.saving': 'Speichert...',
  'songbook.loginRequired': 'Bitte melde dich an, um Songs zu erstellen.',
  'songbook.addChord': 'Akkord',
  'songbook.addTab': 'Tab',
  'songbook.chordName': 'Akkordname (z.B. Am, G7)',
  'songbook.add': 'Hinzufügen',
  'songbook.moveUp': 'Nach oben',
  'songbook.moveDown': 'Nach unten',
  'songbook.delete': 'Löschen',
  'songbook.songTitle': 'Songtitel',
  'songbook.songInfo': 'Allgemeine Infos',
  'songbook.songInfoPlaceholder': 'Tempo, Taktart, Stimmung, Anmerkungen ...',
  'songbook.songNotes': 'Notizen zum Song',
  'songbook.songNotesPlaceholder': 'Notizen, Texte, Anmerkungen ...',
  'songbook.listen': 'Anhören',
  'songbook.listenPlaceholder': 'Link zur Audio-Datei (.mp3, .ogg, .wav ...)',
  'songbook.listenInvalidUrl': 'Bitte eine Audio-Datei angeben (.mp3, .ogg, .wav, .flac, .aac, .m4a)',
  'songbook.elementNote': 'Notiz',
  'songbook.elementNotePlaceholder': 'Anmerkung zu diesem Block ...',
  'songbook.back': 'Zurück',
  'songbook.share': 'Teilen',
  'songbook.shareLink': 'Share-Link',
  'songbook.shareCopied': 'Link kopiert!',
  'songbook.shareStop': 'Teilen beenden',
  'songbook.sharedBy': 'Geteilt von',
  'songbook.files': 'Dateien',
  'songbook.addFile': 'Datei hinzufügen',
  'songbook.fileUploading': 'Wird hochgeladen...',
  'songbook.fileDeleteConfirm': 'Datei löschen?',
  'songbook.noFiles': 'Keine Dateien',
  'songbook.addTablature': 'Tabulatur',
  'songbook.addImage': 'Bild',
  'songbook.addMidi': 'MIDI',
  'songbook.tablatureImport': 'Tab einfuegen',
  'songbook.preview': 'Vorschau',
  'songbook.edit': 'Bearbeiten',
  'songbook.pdf': 'Als PDF',
  'songbook.export': 'Backup exportieren',
  'songbook.import': 'Backup importieren',
  'songbook.exportSuccess': 'Backup wurde heruntergeladen.',
  'songbook.importSuccess': '{{collections}} Kollektionen und {{songs}} Songs importiert.',
  'songbook.importError': 'Fehler beim Import.',

  // Collections
  'songbook.collection': 'Kollektion',
  'songbook.collections': 'Kollektionen',
  'songbook.newCollection': 'Neue Kollektion',
  'songbook.collectionName': 'Name der Kollektion',
  'songbook.addToCollection': 'Zu Kollektion hinzufügen',
  'songbook.newCollectionStart': 'Neue Kollektion beginnen',
  'songbook.artist': 'Künstler / Band',
  'songbook.artistPlaceholder': 'z.B. Die Ärzte, Bach, ...',
  'songbook.collectionHint': 'Eine Kollektion kann eine Setlist, ein Album, eine Sammlung oder ein Projekt sein.',
  'songbook.deleteCollection': 'Kollektion löschen',
  'songbook.deleteCollectionConfirm': 'Leere Kollektion wirklich loeschen?',
  'songbook.deleteCollectionNotEmpty': 'Kollektion enthaelt noch Songs. Bitte zuerst alle Songs loeschen.',
  'songbook.noCollections': 'Noch keine Kollektionen vorhanden.',
  'songbook.songsCount': '{{count}} Songs',
  'songbook.renameCollection': 'Kollektion umbenennen',
  'songbook.tapToRename': 'Doppeltipp zum Umbenennen',
  'songbook.addToPlaylist': '{{count}} Songs zur Playlist hinzufuegen',
  'songbook.selectPlaylist': 'Playlist waehlen',
  'songbook.newPlaylistName': 'Neue Playlist...',
  'songbook.createPlaylist': 'Erstellen',
  'songbook.addedToPlaylist': 'Zur Playlist hinzugefuegt',
  'songbook.playlistCreated': 'Playlist erstellt',
  'songbook.playlists': 'Playlists',
  'songbook.noPlaylists': 'Noch keine Playlists vorhanden.',
  'songbook.deletePlaylistConfirm': 'Playlist wirklich loeschen? (Songs werden nicht geloescht)',
  'songbook.removeFromPlaylist': 'Aus Playlist entfernen',
  'songbook.liveOpacity': 'Farb-Transparenz',
  'songbook.liveFontSize': 'Schriftgroesse',
  'songbook.fontSize.small': 'Klein',
  'songbook.fontSize.medium': 'Mittel',
  'songbook.fontSize.large': 'Gross',
  'songbook.enterFullscreen': 'Vollbild',
  'songbook.exitFullscreen': 'Vollbild beenden',

  // Instruments
  'songbook.instrument.guitar': 'Gitarre',
  'songbook.instrument.bass': 'Bass',
  'songbook.instrument.keyboard': 'Keyboard',
  'songbook.instrument.custom': 'Eigenes',
  'songbook.customInstrumentName': 'Name des Instruments',

  // Songbook Sections
  'songbook.section.intro': 'Intro',
  'songbook.section.strophe': 'Strophe',
  'songbook.section.refrain': 'Refrain',
  'songbook.section.bridge': 'Bridge',
  'songbook.section.mittelteil': 'Mittelteil',
  'songbook.section.solo': 'Solo',
  'songbook.section.coda': 'Coda',
  'songbook.section.custom': 'Custom',
  'songbook.customSectionName': 'Name des Abschnitts',

  // Offline
  'offline.cacheSong': 'Offline speichern',
  'offline.includeAudio': 'Audio-Dateien mitnehmen',
  'offline.noAudioFiles': 'Keine Audio-Dateien vorhanden',
  'offline.files': 'Dateien',
  'offline.startCache': 'Speichern',
  'offline.caching': 'Wird gespeichert...',
  'offline.cachingSong': 'Song wird gespeichert',
  'offline.cachingImage': 'Bild wird gespeichert',
  'offline.cacheSuccess': 'Song ist offline verfuegbar',
  'offline.cacheFailed': 'Offline-Speichern fehlgeschlagen',
  'offline.title': 'Offline gespeicherte Songs',
  'offline.songs': 'Songs',
  'offline.empty': 'Noch keine Songs offline gespeichert.',
  'offline.removeFromOffline': 'Aus Offline-Speicher entfernen',
  'offline.storage': 'Speichernutzung',
  'offline.persistGranted': 'Dauerhaft gespeichert',
  'offline.persistMissing': 'Speicher kann automatisch geleert werden',
  'offline.persistRequest': 'Dauerhaft speichern',
  'offline.openOfflinePage': 'Offline-Speicher verwalten',
  'offline.disabled': 'Offline-Modus ist nicht aktiviert.',
  'offline.pendingSync': '{{count}} noch nicht synchronisiert',
  'offline.pendingSyncHint': 'Diese Eintraege wurden offline angelegt und werden hochgeladen, sobald wieder Netz da ist.',
  'offline.syncNow': 'Jetzt synchronisieren',
  'offline.syncing': 'Synchronisiert...',
} as const
